"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _moment = _interopRequireDefault(require("moment"));
var _dateUtil = _interopRequireDefault(require("./dateUtil"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const storageKeyPrefix = {
  GROUPHISAI: 'home.grouphisai',
  NOTICE: 'home.notice',
  KYOTEN: 'home.kyoten'
};

/**
 * targetIdに対してsavedDtが存在しない、またはtargetDt > savedDtの場合、
 * localStorageにtargetDtを設定する
 * @param {*} targetId
 * @param {*} dt
 * @return 更新した場合true
 */
const setReferencedDetailDt = (targetId, dt) => {
  const id = targetId.trim();
  const targetDt = (0, _moment.default)(dt, _dateUtil.default.DATETIME_FORMAT);
  if (!targetDt.isValid()) {
    return false;
  }
  const savedDt = (0, _moment.default)(localStorage.getItem(id), _dateUtil.default.DATETIME_FORMAT);
  if (!savedDt.isValid()) {
    localStorage.setItem(id, dt);
    return true;
  }
  if (targetDt.isAfter(savedDt)) {
    localStorage.setItem(id, dt);
    return true;
  }
  return false;
};
var _default = exports.default = {
  setReferencedDetailDt,
  storageKeyPrefix
};